"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportButton = ExportButton;
var react_1 = __importDefault(require("react"));
function ExportButton(_a) {
    var fmt = _a.fmt, children = _a.children;
    var url = "/xdh1-api/orders/export?fmt=".concat(fmt);
    return (react_1.default.createElement("a", { href: url, target: "_blank" },
        react_1.default.createElement("button", { className: "zmsk-button" }, children)));
}
